module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "part1"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/004toc#p1"
    }
  }, [_vm._v("The Methods")])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image2"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('img', {
    attrs: {
      "alt": "image 2",
      "src": "images/image-002.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "firstline"
  }, [_vm._v("Cake pops, cupcake pops, cake balls, and bites.")]), _vm._v(" They all have the same things in common: cake, frosting, candy, and cute. But these aren’t ordinary cakes. They are tiny candy-covered confections made of crumbled cake mixed with frosting that you can mold into different shapes and decorate for any occasion. They are super-sweet, extremely moist, and completely covered in candy coating.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Over the next few pages, you’ll find easy instructions that will help you master each of the four methods of creating unique sweet treats. Get ready to impress your friends, your family, and even yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following how-to’s are based on using a cake mix and ready-made frosting. It’s a really easy way to learn the basics and achieve predictable, consistent results. Then, once you feel comfortable making and decorating your very own cake pops, you’ll have the knowledge to branch out with other cake and frosting recipes and get even more creative with custom flavors.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Or just stick with the mixes. I do.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Refer to "), _c('a', {
    attrs: {
      "href": "#/013chapter6"
    }
  }, [_vm._v("Cake Pop Flavor Combinations")]), _vm._v(" for suggested cake mix and ready-made frosting combinations, and "), _c('a', {
    attrs: {
      "href": "#/066part4"
    }
  }, [_vm._v("Cake & Frosting recipes")]), _vm._v(" for easy cake and frosting recipes from scratch.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02cbc780","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006-part1.vue
// module id = 72
// module chunks = 0